import { getTimeZones } from "@vvo/tzdb";
import { DateTime } from "luxon";
import { useState } from "react";
import { RemovingThrobber } from "../../../removing_throbber";
import { SeshSelect } from "../../base_components/sesh_select_input";
import { Disabler } from "../../disabler";
import { SettingsBaseItem } from "../../settings_items/settings_base_item";
import {
	UserPreferenceModifiableSettings,
	useUserPreferencesMutation,
} from "./../user_preferences_modal";

export function UserPreferencesTimezoneItem(props: {
	setting_key: UserPreferenceModifiableSettings;
	label: string;
	description: string;
	value: string;
}) {
	const options = getTimeZones();
	const mutation = useUserPreferencesMutation(props.setting_key);

	const [value, setValue] = useState(options[0]);

	const [is_editing, setIsEditing] = useState(false);

	return (
		<SettingsBaseItem {...props}>
			{!is_editing ? (
				<div className="flex gap-2">
					{mutation.isLoading && <RemovingThrobber />}
					<Disabler disabled={mutation.isLoading}>
						<button
							className="manual-link flex w-fit items-center gap-2"
							onClick={() => setIsEditing(true)}
						>
							<span>{props.value ?? "Not Set"}</span>
							<i className="fas fa-pencil-alt"></i>
						</button>
					</Disabler>
				</div>
			) : (
				<UserPreferencesTimezoneSelect
					initial_value={props.value}
					onSubmit={(val) => {
						mutation.mutate({
							[props.setting_key]: val,
						});
						setIsEditing(false);
					}}
					onCancel={() => setIsEditing(false)}
				/>
			)}
		</SettingsBaseItem>
	);
}

export function UserPreferencesTimezoneSelect(props: {
	initial_value: string | undefined;
	onSubmit: (value: string) => void;
	onCancel: () => void;
}) {
	const options = getTimeZones().map((val) => ({
		label: val.name,
		value: val.name,
	}));

	const local_zone = DateTime.local().zoneName;

	const [value, setValue] = useState(
		props.initial_value
			? options.find((val) => val.value === props.initial_value)
			: options.find((val) => val.value === local_zone)
	);

	return (
		<div className="flex gap-2">
			<div className="w-52">
				<SeshSelect
					value={value}
					onChange={(new_value) => setValue(new_value)}
					options={options}
				/>
			</div>
			<div className="flex gap-1">
				<button
					className="px-1 text-link hover:text-link-hover"
					title="Submit"
					onClick={() => props.onSubmit(value.value)}
				>
					<div className="w-4">
						<i className="fas fa-check"></i>
					</div>
				</button>
				<button
					className="px-1 text-warning hover:text-warning-hover"
					title="Cancel"
					onClick={props.onCancel}
				>
					<div className="w-4">
						<i className="fas fa-times"></i>
					</div>
				</button>
			</div>
		</div>
	);
}
